// 引入方式一：引入默认路径
import NIM from 'nim-web-sdk-ng'

const options = {
  appkey: '173fd2cc71997564d0a504c5ae7a4de1' // 接入时需要将0替换为您的即时通信 IM 应用的SDKAppID
};

const nim = NIM.getInstance({
  appkey: options.appkey,
  debugLevel: process.env.VUE_APP_TIM === 'prod' ? 'off' : 'debug',
  apiVersion: "v2"
})

export default nim;